import ic_exit_session from '@/assets/icons/core/ic_core_logout.svg?raw';
import ic_home from '@/assets/icons/modules/ic_mod_home.svg?raw';
import ic_qr from '@/assets/icons/modules/ic_mod_qr.svg?raw';
import { html, render } from 'lit';
import "../../../styles/pages/Groups.scss";
import { groupContext } from "../../context/group";
import { IGroup } from "../../data/models/Entities";
import { _CHAT_GRUPOS_MENSAJES_NOLEIDOS_MAP, _LoadUnreadedMessage } from "../../data/services/Chat";
import { _ESCUELA, _SvEscuelaObtenerConfiguracion } from "../../data/services/Escuela";
import { _SvUsuarioObtenerGrupos } from "../../data/services/Usuario";
import "../../features/groups/components/GroupsView";
import { GroupsView } from '../../features/groups/components/GroupsView';
import { _HashAssign } from "../../routes/UIManager";
import { _ScanQR } from "../../utils/Device";
import _L from "../../utils/Labels";
import { BaseUI, BaseUIActionMenuItem, MAIN_TOP_OPTIONS_CATALOG } from "../bases/BaseUI";
import { EmptyTag } from "../components/EmptyTag";
import { LOADING } from "../components/Loading";
import { _PROXIMIDAD_CTRL } from "../controllers/ProximidadController";
import { _LogoutDialog } from "../views/LogoutDialog";

export class Groups extends BaseUI {

    private listGroupsContainer: GroupsView;

    private timmerLoadGroup: number = 1000 * 60;
    private idTimeoutLoadGroup: NodeJS.Timeout;
    private listGroups: Array<IGroup> = [];
    private isMainActive: boolean = true;
    private isSecundaryActive: boolean = true;
    private emptyTag: EmptyTag
    private failRequest: boolean = false

    constructor() {
        super({
            addMainLogoOptions: false,
            addOptionsInHeader: false,
            addFooter: true,
            monitorChat: false,
            className: "main_groups",
            includeGroupInHeaderTitle: false
        });

        this.listGroupsContainer = document.createElement('app-groups-view');
        this.listGroupsContainer.addEventListener('group-select', ((e: HTMLElementEventMap["group-select"]) => {
            const grp = e.detail;
            this.OnSelectedGroup(grp);
        }));
        this.bodyContainer.node().appendChild(this.listGroupsContainer);

        this.emptyTag = new EmptyTag(this.bodyContainer.node())
            ._SetSVGIcon(ic_home)
            ._SetColor("var(--color-humor)")

        LOADING.Show();

        this.SetBubblesGroup(this.listGroups);
        this.CreateButtons();

        this.PrepareTopBar()
        this.Init();
    }

    private PrepareTopBar() {
        this.activeHeaderOptions.delete(MAIN_TOP_OPTIONS_CATALOG.classroom.ID);
        this.activeHeaderOptions.delete(MAIN_TOP_OPTIONS_CATALOG.report.ID);
        this.activeHeaderOptions.delete(MAIN_TOP_OPTIONS_CATALOG.chat.ID);

        this.activeHeaderOptions.set("opt_logout", {
            ID: "opt_logout",
            Icon: ic_exit_session,
            Label: 'Cerrar sesión',
            Color: 'var(--color-text1)',
            onClick: _LogoutDialog,
            Order: 1,
        });

        const qrOpt: BaseUIActionMenuItem = {
            ID: "opt_qr",
            Icon: ic_qr,
            Label: 'QR',
            Color: 'var(--color-green)',
            onClick: _ScanQR,
            Order: 2
        }

        const proximityOpt: BaseUIActionMenuItem = MAIN_TOP_OPTIONS_CATALOG.proximity;

        this.activeHeaderOptions.set(qrOpt.ID, qrOpt);
        this.activeHeaderOptions.set(proximityOpt.ID, proximityOpt);

        let showQR = _ESCUELA && _ESCUELA.BolQr;

        !showQR && this.activeHeaderOptions.delete(qrOpt.ID);

        _SvEscuelaObtenerConfiguracion(() => {
            let isShowQR = _ESCUELA && _ESCUELA.BolQr;
            if (isShowQR) { //Agregar QR
                this.activeHeaderOptions.set(qrOpt.ID, qrOpt);
            }
            else {
                this.activeHeaderOptions.delete(qrOpt.ID);
            }

            this.SyncTopBarOptions();
        });

        _PROXIMIDAD_CTRL.onLoadDataCallback = () => this.OnLoadDataProximidad();
    }

    private Init() {
        this.LoadData();

        this.idTimeoutLoadGroup = setInterval(() => {
            this.LoadData();
        }, this.timmerLoadGroup);
    }

    private LoadData() {
        this.failRequest = false
        _SvUsuarioObtenerGrupos((result) => {
            if (!result) {
                this.failRequest = true
            }
            this.listGroups = result || [];
            this.FilterGroups();

            this.CheckMessageUnreaded();

            LOADING.Dismiss();
        });
    }

    private async CheckMessageUnreaded() {
        for (const item of this.listGroups) {
            await new Promise<void>((resolve) => {
                _LoadUnreadedMessage((_) => { resolve(); }, item.IdGrupo);
            });
            this.FilterGroups();
        }
    }

    private SetBubblesGroup(listData: IGroup[]) {
        this.listGroupsContainer.groups = [...(listData.map(o => ({ ...o })))];

        this.RefreshEmptyTag();
    }

    private CreateButtons() {
        const onClickPrimary = (e: Event) => {
            const btnMainEl = e.currentTarget as HTMLElement;
            const isActive = btnMainEl.classList.contains('active');
            this.isMainActive = !isActive;
            btnMainEl.classList.toggle('active', this.isMainActive);

            if (this.failRequest)
                this.LoadData()
            else
                this.FilterGroups()
        }
        const onClickSecundary = (e: Event) => {
            const btnSecEl = e.currentTarget as HTMLElement;
            const isActive = btnSecEl.classList.contains('active');
            this.isSecundaryActive = !isActive;
            btnSecEl.classList.toggle('active', this.isSecundaryActive);

            if (this.failRequest)
                this.LoadData()
            else
                this.FilterGroups()
        }

        render(html`
            <div class="list-buttons-group">
                <app-button class="main active" label="${_L("home.g_prim")}" @click=${onClickPrimary}></app-button>
                <app-button class="secundary active" label="${_L("home.g_sec")}" @click=${onClickSecundary}></app-button>
            </div>
        `, this.footerContainer.node());
    }

    private FilterGroups() {
        let newData: Array<IGroup> = []
        if (this.isMainActive)
            newData = newData.concat(this.listGroups.filter(obj => obj.EsPrincipal));

        if (this.isSecundaryActive)
            newData = newData.concat(this.listGroups.filter(obj => !obj.EsPrincipal));

        newData = newData.sort((a, b) => a.IdGrupo - b.IdGrupo);

        newData.map(o => o.NMessages = _CHAT_GRUPOS_MENSAJES_NOLEIDOS_MAP.get(o.IdGrupo)?.countMsg || 0);

        this.SetBubblesGroup(newData);
    }

    private async OnSelectedGroup(group: IGroup) {
        LOADING.Show();
        const groupChangeSuccess = await groupContext.selectGroup(group);
        _PROXIMIDAD_CTRL._AddSelectedGroup(group);
        LOADING.Dismiss();
        if (groupChangeSuccess) {
            _HashAssign(group.EsPrincipal ? "home" : "classroom");
            _PROXIMIDAD_CTRL._ForceConsult();
        }
    }

    public OnDestroy(): void {
        clearInterval(this.idTimeoutLoadGroup);
        this.idTimeoutLoadGroup = null;
        this.activeHeaderOptions.clear();
        super.OnDestroy();
    }

    private RefreshEmptyTag() {
        let message: string
        if (this.failRequest) {
            message = _L("general.error")
        } else if (!this.listGroups.length) {
            message = _L("home.without_groups")
        } else if (!this.isMainActive && !this.isSecundaryActive) {
            message = _L("home.filter_required")
        } else if ((!this.isMainActive || !this.isSecundaryActive) && !this.listGroupsContainer.groups.length) {
            message = _L("home.groups_no_found")
        }
        if (message) {
            this.emptyTag._SetText(message)._ShowTag()
        } else {
            this.emptyTag._Remove()
        }
    }
}